export default {
  'top-app_bar_spacing-1': {
    top: 56,
    '@media (min-width:0px) and (orientation: landscape)': {
      top: 48
    },
    '@media (min-width:600px)': {
      top: 64
    }
  },
  'margin-app_bar_spacing-1': {
    marginTop: 56,
    '@media (min-width:0px) and (orientation: landscape)': {
      marginTop: 48
    },
    '@media (min-width:600px)': {
      marginTop: 64
    }
  },
  'margin-app_bar_spacing-2': {
    marginTop: 112,
    '@media (min-width:0px) and (orientation: landscape)': {
      marginTop: 96
    },
    '@media (min-width:600px)': {
      marginTop: 128
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/AppBarSpacing.js